module.exports = __webpack_public_path__ + "img/8.cefb0650.png";